import dayjs from 'dayjs';

import { VipTaskItemUserIdentifierTypesEnum } from '@shared/constants';
import { VipTaskItemModel } from '@shared/types';

import { VipTaskItemFormValues } from '../../VipSettingsForms';

export const getVipTaskItemFormValuesFromModel = (item: VipTaskItemModel): VipTaskItemFormValues => {
  const { id, userIdentifierType, joinedTournamentsStartDate, ...restFields } = item;

  return {
    ...restFields,
    userIdentifierType: userIdentifierType || VipTaskItemUserIdentifierTypesEnum.EMAIL,
    joinedTournamentsStartDate: dayjs(joinedTournamentsStartDate),
  };
};
